import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { BaseDtoService, IBaseDto } from './base-dto.service';
import { DivisionClient, SearchDivisionsParameters } from './reporting-api-proxies';

@Injectable({
    providedIn: 'root'
})
export class DepartmentService extends BaseDtoService {
    constructor(private readonly client: DivisionClient) {
        super();
    }

    async getAll(): Promise<IBaseDto[]> {
        return await lastValueFrom(this.client.divisionSearch({ isActive: true } as SearchDivisionsParameters));
    }

    async getById(id: number): Promise<IBaseDto> {
        return await lastValueFrom(this.client.divisionGetById(id));
    }

    async getByIds(divisionIds: number[]): Promise<IBaseDto[]> {
        return await lastValueFrom(this.client.divisionSearch({ divisionIds } as SearchDivisionsParameters));
    }
}
